import {PRESTATION_ROUTES as prestationRoutes} from "~/api/routes";
import {generateOptions} from "~/helpers";
export const state = () => ({
  prestations: [],
  details: null,
  isRequesting:false,
  close:false
});
export const getters = {
  customOptionsForAttach : (state) => {
    return generateOptions(state.prestations);
  },
  optionsPrestations: (state) => (category=null) =>{
    try {
      if (state.prestations)
        if(!category)
          return generateOptions(state.prestations);
        else
          return generateOptions(state.prestations.filter(elem=>{
            if(category !== -1){
              return elem.categories ? elem.categories.filter(unit => unit.categorie_id === category).length === 0 : false
            }
            return true;
          }));
    } catch (e) {
    }
  },
  getAttachedPrestations: (state, getters) => (category) => {
    try {
      const options = getters.customOptionsForAttach;
      return options.filter(elem=>{
        const cats = elem.item.categories;
        return !!cats.find(unit => unit.categorie_id === category)
      })
    } catch (e) {
    }
  },


  getSelectedPrestations: (state, getters) => (prestations) => {
    const options = getters.optionsPrestations();
    return options.filter(elem => prestations.find(y => y === elem.item.article_id))
  },
  prestations: (state)=>  {
    return state.prestations;
  }
};
export const mutations = {
  PRESTATIONS_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.prestations = [];
    //state.page = page;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  PRESTATION_SUCCES(state, prestations) {
    state.prestations = prestations;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  PRESTATIONS_ERROR(state) {
    state.prestations = [];
    state.hasError = true;
  },
  PRESTATIONS_LOADED(state) {
    //state.isLoading = false;
  },
  PRESTATION_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  PRESTATION_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  PRESTATION_ERROR(state) {
    //state.isLoading = false;
  },
  UPDATE_A_PRESTATION(state, prestation) {
    try{
      let index = state.prestations.findIndex((elem) => elem.article_id === prestation.article_id);
      state.prestations = state.prestations.filter(element => element.article_id !== prestation.article_id);
      state.prestations.splice(index, 0, prestation);
    }catch(e){
    }
  },
  PRESTATAIRE_SUCCES(state, details) {
    state.details = details
    //state.isLoading = false;
  },
  ADD_PRESTATION_TO_LIST(state, prestation) {
    state.prestations.unshift(prestation);
  },
  REMOVE_PRESTATION_TO_LIST(state, prestation) {
    state.prestations = state.prestations.filter(element => element.article_id !== prestation.article_id);
  },
  REMOVE_PRESTATAIRE_IMAGE(state, article_id) {
    let index = state.prestations.findIndex((elem) => elem.article_id === article_id);
    state.prestations[index].image = null
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  }
};
export const actions = {
  async getPrestations({commit}) {
    commit('PRESTATIONS_LOAD');
    commit('IS_REQUESTING',true);
    this.$api.request(prestationRoutes.list)
      .then(response => {
        commit('PRESTATION_SUCCES', response.payload);
      })
      .catch(error => {
        commit('PRESTATIONS_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PRESTATIONS_LOADED')
      });
  },
  async createPrestation({commit}, params) {
    commit('PRESTATION_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(prestationRoutes.create, {}, params.formData)
      .then(response => {
        //commit('PRESTATION_SUCCES', response);
        commit('CLOSE_MODAL',true);
        commit('ADD_PRESTATION_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('PRESTATION_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PRESTATION_PROCESSING_END')
      });
  },
  async updatePrestation({commit}, params) {
    commit('PRESTATION_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(prestationRoutes.update, {id: params.id}, params.formData)
      .then(response => {
        //commit('PRESTATION_SUCCES', response);
        commit('UPDATE_A_PRESTATION', response.payload);
        commit('CLOSE_MODAL',true);
      })
      .catch(error => {
        commit('PRESTATION_ERROR');
        commit('CLOSE_MODAL',false);
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PRESTATION_PROCESSING_END');
      })
  },
  async deletePrestation({commit}, params) {
    commit('PRESTATION_PROCESSING_START');
    await this.$api.request(prestationRoutes.delete, {id: params.article_id})
      .then(response => {
        //commit('PRESTATION_SUCCES', response);
        commit('REMOVE_PRESTATION_TO_LIST', params);
      })
      .catch(error => {
        commit('PRESTATION_ERROR');
      })
      .finally(() => commit('PRESTATION_PROCESSING_END'));
  },
  async getPrestation({commit}, params) {
    commit('PRESTATION_PROCESSING_START');
    await this.$api.request(prestationRoutes.get, {id: params.article_id})
      .then(response => {
        commit('PRESTATAIRE_SUCCES', response.payload);
      })
      .catch(error => {
        commit('PRESTATION_ERROR');
      })
      .finally(() => commit('PRESTATION_PROCESSING_END'));
  },
  async removeImage({commit}, params) {
    commit('REMOVE_PRESTATAIRE_IMAGE', params.id);
  }
};
